
const data = [
  {
    title: '流程变革方法论概述',
    description: '基于企业的业务环境、资源配置和流程接口展开，明确改善指标要素，从端到端全流程视角立体进行呈现。'
  },
  {
    title: '服务内容',
    description: '落实变革项目管理方法论\n' +
      '流程优化的原则和方法论\n' +
      '流程管理长效机制的建立和持续优化'
  },
  {
    title: '服务特点',
    description: '寻求在对标基础上的关键要素改善的具体内容，实现组织与职责优化、流程技术优化、授权优化和绩效优化的联动。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/train-flow.js